export const SurveyType = {
  survey: 'survey',
  template: 'template',
}
